import { BreadcrumbBar } from 'components/breadcrumb-bar';
import { Box, HStack, IconButton, Text, Tooltip, useBreakpointValue } from 'design-system';
import { MenuIcon } from 'layout/components/header/icons/menu-icon';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { toggleMobileSidebar, toggleSidebar } from 'redux/sidebar/reducer';
import IntlMessages from 'utils/intl-messages';

export function HeaderLeft(): JSX.Element {
  const isSidebarOpen = useAppSelector((state) => state.sidebar.isOpen);
  const { title } = useAppSelector((state: any) => state.settings);
  // const match = useRouteMatch();
  const dispatch = useAppDispatch();
  const isMobile = useBreakpointValue({ base: true, md: false });

  const handleToggleSidebar = () => {
    // Below md the rail is hidden — the same button drives the overlay drawer
    dispatch(isMobile ? toggleMobileSidebar() : toggleSidebar());
  };

  return (
    <Box me='auto' minW={0}>
      <HStack spacing='0.5rem'>
        <Box onClick={handleToggleSidebar}>
          <Tooltip label={isMobile ? 'Open menu' : isSidebarOpen ? 'Collapse menu' : 'Expand menu'}>
            <IconButton aria-label='sidebar' icon={<MenuIcon />} isRound variant={'ghost'} size={'lg'} />
          </Tooltip>
        </Box>

        {title && (
          <Box minW={0} overflow='hidden'>
            {/* The multi-level breadcrumb doesn't fit a phone header — show a
                single truncated title instead */}
            <Box display={{ base: 'none', md: 'block' }}>
              <BreadcrumbBar />
            </Box>

            <Text display={{ base: 'block', md: 'none' }} fontSize='md' fontWeight='semibold' isTruncated>
              <IntlMessages id={title} />
            </Text>
          </Box>
        )}
      </HStack>
    </Box>
  );
}
